import Flickity from 'flickity';
import { gsap, Observer } from "../global/gsap";

const initPeopleCards = (peopleCards) => {
    // peopleCards.forEach((card) => {
    //     const pill = document.createElement('div');
    //     pill.className = 'person-card__pill';
    //     pill.innerText = 'Bio';

    //     card.appendChild(pill);

    //     gsap.set(pill, {
    //         xPercent: -50,
    //         yPercent: -50,
    //         opacity: 0
    //     });

    //     Observer.create({
    //         target: card,
    //         type: "pointer",
    //         onHover: (self) => {
    //             const rect = card.getBoundingClientRect();

    //             gsap.set(pill, {
    //                 x: self.x - rect.left,
    //                 y: self.y - rect.top
    //             });

    //             gsap.to(pill, {
    //                 opacity: 1,
    //                 duration: 0.3
    //             });
    //         },
    //         onMove: (self) => {
    //             const rect = card.getBoundingClientRect();
    //             const relX = self.x - rect.left;
    //             const relY = self.y - rect.top;

    //             gsap.to(pill, {
    //                 x: relX,
    //                 y: relY,
    //                 duration: 0.4,
    //                 ease: "power3.out",
    //                 overwrite: "auto"
    //             });
    //         },
    //         onHoverEnd: () => {
    //             gsap.to(pill, {
    //                 opacity: 0,
    //                 duration: 0.2,
    //                 ease: "power2.in" 
    //             });
    //         }
    //     });
    // });

    const carouselEl = document.querySelector('.js-people-carousel');

    const flickityOptions = {
        cellAlign: 'left',
        wrapAround: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        setGallerySize: true,
        cellSelector: '.person-card',
        contain: true
    };

    const flkty = new Flickity(carouselEl, flickityOptions);

    flkty.on('dragStart', () => {
        flkty.slider.style.pointerEvents = 'none';
    });

    flkty.on('dragEnd', () => {
        flkty.slider.style.pointerEvents = 'auto';
    });
};

export { initPeopleCards as default };
